import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getCareers } from "../lib/api";
import { SectionTitle, Loader } from "../components/Shared";
import * as Icons from "lucide-react";
import { ArrowRight } from "lucide-react";

export default function Careers() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    getCareers().then(setData).finally(() => setLoading(false));
  }, []);

  return (
    <div className="max-w-7xl mx-auto px-5 md:px-10 py-8 md:py-12" data-testid="careers-page">
      <SectionTitle
        kicker="Careers"
        title="From curiosity to a career."
        subtitle="Six pathways that connect what you love with what the world needs — built around EduSphere's hands-on STEM models."
      />
      {loading && <Loader label="Loading pathways…" />}
      {data && (
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
          {data.pathways.map((p, i) => {
            const Icon = Icons[p.icon] || Icons.Briefcase;
            return (
              <div key={i} className="card p-6 flex flex-col" data-testid={`career-card-${i}`}>
                <div className="flex items-center gap-3 mb-3">
                  <div className="w-11 h-11 rounded-xl bg-[#FBE7DF] grid place-items-center text-[#E07A5F]">
                    <Icon size={20} />
                  </div>
                  <div className="font-heading font-semibold text-lg leading-tight">{p.role}</div>
                </div>
                <div className="text-[11px] tracking-[0.18em] uppercase text-[#3A5A40] font-semibold mt-2">Skills you'll build</div>
                <div className="flex flex-wrap gap-1.5 mt-1.5">
                  {p.skills.map((s, j) => (
                    <span key={j} className="badge" data-testid={`career-${i}-skill-${j}`}>{s}</span>
                  ))}
                </div>
                <div className="text-[11px] tracking-[0.18em] uppercase text-[#3A5A40] font-semibold mt-4">EduSphere models</div>
                <div className="flex flex-wrap gap-1.5 mt-1.5">
                  {p.models.map((m, j) => (
                    <button
                      key={j}
                      onClick={() => navigate(`/chat?topic=${encodeURIComponent(m)}`)}
                      data-testid={`career-${i}-model-${j}`}
                      className="text-xs bg-[#F4F1EA] border border-[#DCD7CE] hover:border-[#E07A5F] hover:text-[#E07A5F] px-2.5 py-1 rounded-full transition"
                    >
                      {m}
                    </button>
                  ))}
                </div>
                <div className="bg-[#EAECE6] rounded-xl p-3 mt-5 border border-[#DCD7CE]">
                  <div className="text-[10px] tracking-[0.18em] uppercase text-[#3A5A40] font-semibold">Starter project</div>
                  <div className="text-sm text-[#1A1A1A] mt-1">{p.starter}</div>
                </div>
                <button
                  onClick={() => navigate(`/paths?topic=${encodeURIComponent(p.role)}`)}
                  className="btn-outline mt-5 inline-flex items-center justify-center gap-2"
                  data-testid={`career-${i}-path`}
                >
                  Build a learning path <ArrowRight size={14} />
                </button>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
